import { Button } from "@omni/ui/components/Button/button.component";
import { ButtonComponentProps } from "@omni/ui/components/Button/button.props";
import { cn } from "@omni/utils/styles";
import { MouseEvent } from "react";

import { useFlyoutContext } from "@/components/General/Flyout/context/flyout.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = Omit<ButtonComponentProps, "type">;

export const CloseButton = ({
    className,
    onClick,
    children,
    ...props
}: Props) => {
    const { t } = useGranite();

    const { onClose } = useFlyoutContext();

    const handleOnButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
        onClick?.(event);

        if (!event.isDefaultPrevented()) {
            onClose();
        }
    };

    return (
        <Button
            type={"button"}
            onClick={handleOnButtonClick}
            className={cn("tw:first-letter:uppercase", className)}
            {...props}
        >
            {children ?? t("general.alert.close")}
        </Button>
    );
};
